(() => {
  const config = document.querySelector('[data-pmp-style-config]');
  if (!config) return;
  const threshold = Number(config.dataset.threshold) || 8;
  const selector = '.mega__list a[href*="/collections/"], .mnav__sub a[href*="/collections/"], #stile .card--style[href*="/collections/"], .collection-tiles .tile[href*="/collections/"], .tiles .tile[href*="/collections/"]';
  /* Zweitprüfung F010 (29.10.2026): Der Zähler prüft deutsche Stilwörter in den Bild-Alt-Texten. In Fremdsprachen sind die Alt-Texte übersetzt,
     deshalb wird immer die deutsche Fassung gezählt und das Ergebnis über die Zeilenreihenfolge auf den lokalisierten Handle übertragen. */
  const base = new URL(config.dataset.url, location.origin);
  const deBase = new URL(base.pathname.replace(/^\/[a-z]{2}(-[a-z]{2})?(?=\/|$)/i, '') || '/', location.origin);
  async function readCounts(page, from) {
    const url = new URL(from.pathname, location.origin);
    url.searchParams.set('section_id', 'pmp-style-availability');
    url.searchParams.set('page', String(page));
    if (window.Shopify && Shopify.theme && Shopify.theme.id && Shopify.theme.role !== 'main') url.searchParams.set('preview_theme_id', Shopify.theme.id);
    const response = await fetch(url, {credentials: 'same-origin'});
    if (!response.ok) throw new Error('Stilbestand nicht abrufbar');
    const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
    const rows = [...doc.querySelectorAll('[data-style-handle]')];
    if (!rows.length) throw new Error('Stilbestand fehlt');
    return rows;
  }
  async function update() {
    try {
      const first = await readCounts(1, deBase);
      const counts = new Map();
      for (const row of first) counts.set(row.dataset.styleHandle, Number(row.dataset.count));
      const maxPages = Math.max(...first.map(row => Number(row.dataset.pages)));
      for (let page = 2; page <= maxPages; page++) {
        if ([...counts.values()].every(count => count >= threshold)) break;
        for (const row of await readCounts(page, deBase)) {
          if (Number(row.dataset.pages) >= page) counts.set(row.dataset.styleHandle, (counts.get(row.dataset.styleHandle) || 0) + Number(row.dataset.count));
        }
      }
      if (deBase.pathname !== base.pathname) {
        for (const row of await readCounts(1, base)) {
          if (row.dataset.styleLocal) counts.set(row.dataset.styleLocal, counts.get(row.dataset.styleHandle) || 0);
          /* F010 Rest (30.10.2026): Kartenlinks nutzen die übersetzte URL; deren Handle ebenfalls zuordnen */
          if (row.dataset.styleUrl) { const lh = row.dataset.styleUrl.split('/collections/')[1]; if (lh) counts.set(decodeURIComponent(lh.split('/')[0]), counts.get(row.dataset.styleHandle) || 0); }
        }
      }
      for (const link of document.querySelectorAll(selector)) {
        const handle = new URL(link.href, location.origin).pathname.split('/collections/')[1]?.split('/')[0];
        /* F010 Nachtrag: übersetzte Sammlungsnamen (z. B. watercolour-pet-portraits) enthalten kein „stil-“; nur bekannte Stilsammlungen schalten */
        if (!counts.has(handle)) continue;
        const ready = (counts.get(handle) || 0) >= threshold;
        link.toggleAttribute('data-pmp-style-ready', ready);
        link.hidden = !ready;
        if (link.parentElement.matches('li')) {
          link.parentElement.toggleAttribute('data-pmp-style-ready', ready);
          link.parentElement.hidden = !ready;
        }
      }
      for (const note of document.querySelectorAll('[data-pmp-style-notice]')) {
        note.hidden = (counts.get(note.dataset.pmpStyleNotice) || 0) >= threshold;
      }
      config.dataset.status = 'complete';
      config.dataset.counts = JSON.stringify(Object.fromEntries(counts));
    } catch (error) {
      config.dataset.status = 'error';
      console.warn('Stilbestand konnte nicht geprüft werden.', error);
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', update, {once:true});
  else update();
  document.addEventListener('shopify:section:load', update);
})();
